import { COUNTDOWN_TICK_DELAY_MS } from "../constants";

const MS_PER_SECOND = 1000;

/**
 * Calls `onTick` once, right after the next whole second of the clock, when
 * the bar timer shows a new value (bars open at whole seconds). The owner
 * calls setRunning after every draw, so it ticks only while the timer is on screen.
 *
 * @param {() => void} onTick
 * @returns {{ setRunning: (isRunning: boolean) => void, stop: () => void }}
 */
export const createCountdownTicker = (onTick) => {
  let timeoutId = null;

  const stop = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
  };

  return {
    setRunning: (isRunning) => {
      if (!isRunning) {
        stop();
        return;
      }

      if (timeoutId !== null) return;

      const delay = MS_PER_SECOND - (Date.now() % MS_PER_SECOND) + COUNTDOWN_TICK_DELAY_MS;

      timeoutId = setTimeout(() => {
        timeoutId = null;
        onTick();
      }, delay);
    },

    stop,
  };
};
